var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',[_c('alter-form',{ref:"alterForm",attrs:{"modifyData":_vm.modifyData,"formData":_vm.formData,"collapseLength":_vm.collapseLength},on:{"handleChange":_vm.handleChange,"formSubmit":_vm.formSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }